import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Sirve para todos los casos de rodilla?',
    answer: 'Sí. Los 6 tomos cubren desde la evaluación inicial hasta el retorno deportivo y el manejo en adultos mayores con artrosis.'
  }, {
    question: '¿Cómo recibo el material?',
    answer: '100% digital. A los 5 minutos de tu compra recibís el acceso por email con todos los PDFs descargables.'
  }, {
    question: '¿Qué diferencia hay con material gratuito online?',
    answer: 'El Atlas está adaptado al contexto clínico argentino, basado en evidencia actualizada y listo para usar sin necesidad de adaptar nada.'
  }, {
    question: '¿Tiene garantía real?',
    answer: 'Sí. 7 días, devolución completa, sin preguntas. Menos del 1% de devoluciones habla por sí solo.'
  }];
  return <section className="w-full bg-[#0a1410] py-8 md:py-16" data-id="element-69">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-71">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-6 md:mb-12" data-id="element-72">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>

          <div className="space-y-3 md:space-y-4" data-id="element-73">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.4
          }} className="bg-[#0f1f17] border border-amber-900/30 rounded-lg overflow-hidden" data-id="element-74">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-[#0a1410] transition-colors" data-id="element-75">
                  <span className="text-lg font-semibold text-white pr-4" data-id="element-76">
                    {faq.question}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-amber-500 flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-77" />
                </button>

                <AnimatePresence data-id="element-78">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-79">
                      <div className="px-6 pb-6 text-gray-300 leading-relaxed" data-id="element-80">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}